import React, { createContext, useContext, PropsWithChildren } from 'react';
import { scopedVersion } from '@bloomberg/crescent-tokens/js/utils';

export const SCOPED_CSS_VERSION = `v${scopedVersion}`;

export const ScopedCssContext = createContext<string | undefined>(undefined);

export function useScopedCss() {
    return useContext(ScopedCssContext);
}

export function getScopedProps(scopeValue: string | undefined) {
    return scopeValue ? { 'data-cds-scoped': scopeValue } : {};
}

export interface ScopedCssProviderProps {
    enabled?: boolean;
}

export function ScopedCssProvider({ enabled = true, children }: PropsWithChildren<ScopedCssProviderProps>) {
    const value = enabled ? SCOPED_CSS_VERSION : undefined;
    return <ScopedCssContext.Provider value={value}>{children}</ScopedCssContext.Provider>;
}
